export default __webpack_public_path__ + "static/media/Ghulam_Muhammad_Soomro.1854a371.png";